import { render, staticRenderFns } from "./AppAvatarMenu.vue?vue&type=template&id=4cf53b8c&scoped=true"
import script from "./AppAvatarMenu.vue?vue&type=script&lang=js"
export * from "./AppAvatarMenu.vue?vue&type=script&lang=js"
import style0 from "./AppAvatarMenu.vue?vue&type=style&index=0&id=4cf53b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf53b8c",
  null
  
)

export default component.exports